import React from "react";
import { CheckCircle } from "lucide-react";
import { formatAudAmount } from "../../../utils/audCurrency";

const TutorSidebar = ({ tutor, topicsTaught, availability, onBookSession }) => {
  const topicList = Array.isArray(topicsTaught) ? topicsTaught : [];

  return (
    <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200">
      <p className="text-gray-700 text-sm">Session Rate</p>

      <p className="text-4xl font-bold text-[#08A595] mt-1">
        {typeof tutor.price === "number" ? formatAudAmount(tutor.price) : "On request"}
      </p>
      <p className="text-gray-500 -mt-1">per session</p>

      <div className="mt-6">
        <h4 className="font-semibold text-gray-900 text-sm mb-2">
          Area of Expertise
        </h4>

        <div className="bg-[#F5F7FA] rounded-xl p-4 border border-gray-200 text-gray-700 space-y-1 text-sm">
          {topicList.length ? (
            topicList.map((topic, i) => <p key={i}>{topic}</p>)
          ) : (
            <p>Topics not provided.</p>
          )}
        </div>
      </div>

      <div className="mt-6">
        <div className="bg-[#E6F9F2] rounded-xl px-4 py-3 border border-green-200">
          <p className="text-[#0C9A79] font-medium text-sm flex items-center gap-2">
            <CheckCircle size={18} />
            Experienced and friendly teacher
          </p>
        </div>
      </div>

      <button
        onClick={onBookSession}
        className="mt-8 w-full bg-[#0736D6] text-white py-3 rounded-xl shadow-md font-medium hover:bg-[#062FC0] transition"
      >
        Book a Session
      </button>
    </div>
  );
};

export default TutorSidebar;
